import React from 'react';

import { faUserShield } from '@fortawesome/pro-regular-svg-icons';

import AutocompleteSearch from '../components/AutocompleteSearch';
import StrongTextField from '../components/StrongTextField';

export default {
  title: 'Délégués',
  name: 'delegues',
  icon: faUserShield,
  resource: 'opti9_delegues_prog',
  primaryKey: 'iddelegueprog',
  query: { _associations: '*individu' },
  head: {
    'individu.nom': 'Nom',
    'individu.prenom': 'Prénom',
    'individu.email': 'Email',
  },
  filter: ({ values, props }) => [
    <StrongTextField suffix='%' name="['individu.nom']" label='Nom' value={values['individu.nom']} {...props} />,
  ],
  list: ({ values }) => [values.individu?.nom, values.individu?.prenom, values.individu?.email],
  edit: ({ values, props, setValues }) => [
    <AutocompleteSearch
      {...props}
      resource='individu'
      attributeId='idindividu'
      optionLabel={option => option.nom + ' ' + option.prenom}
      attribute='nom'
      value={values.idindividu}
      label='Délégué'
      onChange={(event, value) => value && setValues({ ...values, idindividu: value.idindividu })}
    />,
  ],
  add: true,
  popup: true,
  remove: true,
};
